// js/common/megaNav.js
export function initMegaNav({
  breakpoint = 1025,
  headerSelector = ".l-header",
  headerOpenClass = "is-mega-open",
  closeOnScroll = "down", // "down" | "any"
} = {}) {
  const nav = document.querySelector(".l-header__nav.--pcOnly");
  if (!nav) return () => {};
  const header = document.querySelector(headerSelector);
  const mm = window.matchMedia(`(min-width:${breakpoint}px)`);

  let enabled = false;
  let lastScrollY = window.scrollY;
  const MIN_DELTA = 6;

  const anyOpen = () => !!nav.querySelector(".hasMega.is-open");

  const updateHeaderState = () => {
    if (!header) return;
    header.classList.toggle(headerOpenClass, anyOpen());
  };

  const closeAll = (exceptLi) => {
    nav.querySelectorAll(".hasMega.is-open").forEach((li) => {
      if (li !== exceptLi) {
        li.classList.remove("is-open");
        li.querySelector(".navParent")?.setAttribute("aria-expanded", "false");
      }
    });
    updateHeaderState();
  };

  const onNavClick = (e) => {
    const btn = e.target.closest(".navParent");
    if (!btn) return;
    const li = btn.closest(".hasMega");
    const isOpen = li.classList.contains("is-open");
    closeAll(li);
    li.classList.toggle("is-open", !isOpen);
    btn.setAttribute("aria-expanded", String(!isOpen));
    updateHeaderState();
  };

  // ★ ここが追加：スクロールでメガナビを閉じる
  const onScroll = () => {
    if (!anyOpen()) {
      lastScrollY = window.scrollY;
      return;
    }

    const y = window.scrollY;
    const diff = y - lastScrollY;

    if (closeOnScroll === "any") {
      closeAll();
    } else {
      // "down" のときは下方向のみ
      if (diff > MIN_DELTA) closeAll();
    }
    lastScrollY = y;
  };

  // ホイール／タッチ移動でも閉じる（ブラウザ差対策）
  const onWheel = () => anyOpen() && closeAll();
  const onTouchMove = () => anyOpen() && closeAll();

  const onDocClick = (e) => {
    if (!nav.contains(e.target)) closeAll();
  };
  const onKeydown = (e) => {
    if (e.key === "Escape") closeAll();
  };

  const enable = () => {
    if (enabled) return;
    nav.addEventListener("click", onNavClick);
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKeydown);

    // 追加イベント
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("wheel", onWheel, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });

    enabled = true;
  };

  const disable = () => {
    if (!enabled) return;
    nav.removeEventListener("click", onNavClick);
    document.removeEventListener("click", onDocClick);
    document.removeEventListener("keydown", onKeydown);

    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("wheel", onWheel);
    window.removeEventListener("touchmove", onTouchMove);

    closeAll();
    header?.classList.remove(headerOpenClass);
    enabled = false;
  };

  const apply = () => (mm.matches ? enable() : disable());
  mm.addEventListener("change", apply);
  apply();

  return () => {
    mm.removeEventListener?.("change", apply);
    disable();
  };
}
